import { useCallback, useMemo } from "react";
import { Button } from "@mantine/core";

interface IhcResendButtonProps {
  slide: any;
  isPending: boolean;
  onResend: (slideId: string) => Promise<void>;
}

export function IhcResendButton({
  slide,
  isPending,
  onResend,
}: IhcResendButtonProps) {
  const isDisabled = useMemo(() => {
    const queue = slide.ihcQueue;
    const eligible = ["ready_for_staining", "staining_in_progress"].includes(
      slide.status
    );
    return (
      !eligible ||
      !slide.stainerType ||
      Boolean(queue?.processedAt) ||
      queue?.status === "processing" ||
      Boolean(queue?.inFlightStainerType) ||
      queue?.lastSuccessfulStainerType === slide.stainerType ||
      isPending
    );
  }, [isPending, slide]);

  const handleResend = useCallback(() => {
    void onResend(slide.id);
  }, [onResend, slide.id]);

  return (
    <Button
      size="xs"
      variant="light"
      onClick={handleResend}
      disabled={isDisabled}
      loading={isPending}
    >
      Resend
    </Button>
  );
}
